
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 6h26v20H3V6zm2 2v4h22V8H5zm2 1h8v2H7V9zm17 0a1 1 0 110 2 1 1 0 010-2zM5 14v4h22v-4H5zm2 1h8v2H7v-2zm17 0a1 1 0 110 2 1 1 0 010-2zM5 20v4h22v-4H5zm2 1h8v2H7v-2zm17 0a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    